import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HiOutlineMail, HiOutlineLockClosed, HiEye, HiEyeOff, HiOutlineArrowLeft } from 'react-icons/hi';
import toast from 'react-hot-toast';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      toast.error('Please fill in all fields');
      return;
    }
    setLoading(true);
    try {
      await login(formData.email, formData.password);
      toast.success('Login successful! Welcome back.');
      navigate('/dashboard');
    } catch (error) {
      const msg = error.response?.data?.message || 'Login failed. Please try again.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" style={{
      backgroundImage: 'var(--auth-bg-gradient), url("/factory_bg.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      <Link to="/" style={{
        position: 'absolute', top: '24px', left: '24px', zIndex: 100,
        display: 'flex', alignItems: 'center', gap: '8px',
        color: 'var(--text-secondary)', fontWeight: 600, fontSize: '0.9rem',
        textDecoration: 'none', padding: '8px 16px', borderRadius: '8px',
        background: 'var(--bg-secondary)', border: '1px solid var(--border)',
        boxShadow: 'var(--shadow-sm)', transition: 'var(--transition-fast)'
      }} className="back-to-home">
        <HiOutlineArrowLeft /> Back to Home
      </Link>
      <div className="auth-left">
        <div className="auth-branding">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
            <img src="/logo.png" alt="TrackBells Logo" style={{ maxHeight: '110px', maxWidth: '320px', objectFit: 'contain' }} />
          </div>
          <p>Complete factory automation from Gate Entry to Godown — production tracking, quality control, and inventory management all in one place.</p>
          <div className="tagline">Factory Automation System</div>
        </div>
      </div>

      {/* Right - Login Form */}
      <div className="auth-right">
        <div className="auth-form-container">
          <h2>Welcome Back</h2>
          <p className="subtitle">Enter your credentials to access the dashboard</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <div className="form-input-icon">
                <HiOutlineMail className="icon" />
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  autoFocus
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="form-input-icon">
                <HiOutlineLockClosed className="icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="form-input"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <HiEyeOff /> : <HiEye />}
                </button>
              </div>
            </div>

            <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>

            <button
              type="submit"
              className="btn btn-primary btn-block btn-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner spinner-sm" style={{ width: 18, height: 18, borderWidth: 2 }} />
                  Signing In...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="auth-link">
            Don't have an account? <Link to="/signup">Create Account</Link>
          </div>
          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.85rem' }}>
            <Link to="/privacy-policy" style={{ color: 'var(--text-secondary)' }}>Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
